import {React, useState} from 'react';


const Info = () => {

    const  [infoOpen, setInfoOpen] = useState(true);
    
    return  ( <>{infoOpen &&
        <div className="info"> 
          <b>About ⓘ </b> <br/>
        Multiple studies have highlighted the need for more research analyzing the effects of public transportation accessibility in the healthcare sphere. We created a framework for a public transit routing system that is comprised of free, publicly available data and software that is completely offline and thus compatible with a secure research environment to protect patient data. 
        <br/><br/> We hope that bringing attention to an easy to implement method for public transit routing with single-patient level precision in healthcare will greatly improve our understanding of social determinants of health, the differential impacts of transit access across the healthcare system, and possible solutions to transportation issues.
        <br/><br/>This visualization is a demonstration of one way this data could be used. For more information on this project, please see our paper here.
        <br/><button onClick={()=> setInfoOpen(false)}>Close</button>
        </div>
  }</>)
}

export default Info;